import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../../../actions";
import strings from "../../../helpers/Localization";

//CUSTOM COMPONENT
import Modal from "../../../aGlobalDesign/Modal/Modal";
import Area from "../../../aGlobalDesign/Area/Area";
import ButtonSKA from "../../../aGlobalDesign/Buttons/ButtonSKA";
import ButtonSkaRound from "../../../aGlobalDesign/Buttons/ButtonSkaRound";
import classNames from "classnames";
import IconComponent from "../../../aGlobalDesign/Icons/IconComponent";
import Loader from "../../../aGlobalDesign/Loader/Loader";
import Tooltips from "../../../aGlobalDesign/Tooltips/Tooltips";
import CardDecisionTree from "../../../aGlobalDesign/Cards/CardDecisionTree";
import Drawer from "../../../aGlobalDesign/Modal/Drawer";
import Inputs from "../../../aGlobalDesign/Inputs/Inputs";
import Badge from "../../../aGlobalDesign/Badges/Badge";
import PageMetaHelmet from "../../../aGlobalDesign/PageMetaHelmet/PageMetaHelmet";

class EditDecisionTree extends React.Component {

    constructor() {
        super();
        this.state = {
            hasChange: false,
            compactMode: false,
            decisionTree: null,
            branchToEdit: null,
            selectedCard: null,
            draggingItem: null,
            newIdCount: 0,
            filesList: []
        };
        this.onCreateNewBranch = this.onCreateNewBranch.bind(this);
        this.onEditBranch = this.onEditBranch.bind(this);
        this.onDeleteBranch = this.onDeleteBranch.bind(this);
        this.selectBranch = this.selectBranch.bind(this);
        this.onFindBranchById = this.onFindBranchById.bind(this);
    }
    componentDidMount() {
        this.props.changeAppBarTitle(strings.DecisionTrees);
        this.props.ChangeCurrentMenuName("DecisionTrees");

        const vars = window.location.search.substring(1).split("&");
        for (let i = 0; i < vars.length; i++) {
            const pair = vars[i].split("=");
            if (pair[0] === "id") {
                if (pair[1] === "0") {
                    const newDecisionTree = {
                        id: 0,
                        name: "",
                        description: "",
                        branches: [],
                        homePageLinks: [],
                        alwaysShow: false,
                        callCenterId: null,
                        zoneId: null,
                        timestamp: null
                    };
                    this.setState({ decisionTree: newDecisionTree });
                }
                else {
                    this.props.GetDecisionTree(pair[1], (data) => {
                        if (!this.props.monitoring.secondarycallcenters) {
                            this.props.GetSecondaryCallCentersList((data) => {});
                        }
                        this.setState({ decisionTree: data });
                    });
                }
            }
        }
    }

    setDecisionTree(value) {
        this.setState({ decisionTree: value });
    }

    setHasChange(value) {
        this.setState({ hasChange: value });
    }

    //#region functions
    onFindBranchById(tree, branchId) {
        if (!tree.branches) {return null;}
        for (let i = 0; i < tree.branches.length; i++) {
            if (tree.branches[i].id === branchId) { return tree.branches[i]; }
            else {
                const r = this.onFindBranchById(tree.branches[i], branchId);
                if (r !== null) {return r;}
            }
        }
        return null;
    }

    onCreateNewBranch(levelIndex, parentid) {
        let newIdCount = this.state.newIdCount;
        newIdCount--;

        const tempTree = this.state.decisionTree;
        const parent = levelIndex === 0 ? tempTree : this.onFindBranchById(tempTree, parentid);
        if (!parent.branches) {parent.branches = [];}
        const branch = {
            id: newIdCount,
            position: parent.branches.length > 0 ? parent.branches[parent.branches.length - 1].position + 1 : 0,
            name: "",
            branches: [],
            callDecisionTreeId: levelIndex === 0 ? parentid : null,
            callTreeBranchId: levelIndex > 0 ? parentid : null,
            documentURL: null,
            documentName: null,
            text: null,
            linkURL: null,
            linkName: null,
            callCenterId: tempTree.callCenterId,
            showCallCenter: tempTree.callCenterId ? true : false
        };

        parent.branches.push(branch);

        this.setState({
            hasChange: true,
            newIdCount: newIdCount,
            decisionTree: tempTree,
            branchToEdit: { levelIndex: levelIndex, branch: branch, newBranch: true }
        });
    }
    onAddFiles(branch, levelIndex, inputFiles, isHPLink) {
        const filesList = this.state.filesList;
        const tempTree = this.state.decisionTree;
        const tbranch = isHPLink ? branch : this.onFindBranchById(tempTree, branch.id);

        /*
        tempEdit.hmplink.photoName = hpLink.photoName;
        tempEdit.hmplink.photoURL = hpLink.photoURL;
        tempEdit.hmplink.photoThumbnailURL = hpLink.photoThumbnailURL;
        */
        console.log("tbranch", tbranch);

        for (let i = 0; i < inputFiles.length; i++) {
            if (inputFiles[i].size > this.props.configuration.multipartBodyLengthLimit) {
                this.props.OpenDialog({
                    title: strings.fileTooBig,
                    description: strings.fileTooBigDesc + this.props.configuration.multipartBodyLengthLimit / 1000000 + "MB",
                    primaryLabel: "OK",
                    clickOutsideToClose: true
                });
                return;
            }
            if (!filesList.some(e => e.name === inputFiles[i].name)) {
                filesList.push(inputFiles[i]);
            }
            if (isHPLink) {
                tbranch.photoName = inputFiles[i].name;
                tbranch.photoURL = inputFiles[i].name;
                tbranch.photoThumbnailURL = null;
            }
            else {
                tbranch.documentName = inputFiles[i].name;
                tbranch.documentURL = inputFiles[i].name;
            }
        }

        this.setState({
            hasChange: true,
            decisionTree: tempTree,
            filesList: filesList
        });
        return tbranch;
    }

    onEditBranch(branch, levelIndex) {
        this.setState({ branchToEdit: { levelIndex: levelIndex, branch: branch, newBranch: false } });
    }
    onDeleteBranch(branch, levelIndex) {
        const tempTree = this.state.decisionTree;
        if (levelIndex === 0) {
            const branchIndex = tempTree.branches.findIndex(b => b.id === branch.id);
            tempTree.branches.splice(branchIndex, 1);
        }
        else {
            const branchParent = this.onFindBranchById(tempTree, branch.callTreeBranchId);
            const branchIndex = branchParent.branches.findIndex(b => b.id === branch.id);
            branchParent.branches.splice(branchIndex, 1);
        }
        this.setState({
            hasChange: true,
            branchToEdit: null,
            decisionTree: tempTree,
            selectedCard: null
        });
    }

    onSaveCurrent() {
        const decisionTree = this.state.decisionTree;

        const d = {
            id: decisionTree.id,
            name: decisionTree.name,
            description: decisionTree.description,
            zoneId: decisionTree.zoneId,
            callCenterId: decisionTree.callCenterId,
            organizationId: this.props.currentuser.currentorganization.id,
            timestamp: decisionTree.timestamp,
            branches: decisionTree.branches,
            homePageLinks: decisionTree.homePageLinks,
            alwaysShow: decisionTree.alwaysShow
        };
        this.props.EditDecisionTree( this.state.filesList, d,
            (updatedDisplayTimestamp) => {
                this.props.GetDecisionTree(decisionTree.id, (data) => {
                    this.setState({
                        hasChange: false,
                        decisionTree: data
                    });
                });
            }
        );
    }

    openAllCards() {
        const decisionsTree = this.state.decisionTree;
        let branches = [];
        if (decisionsTree.branches) {
            decisionsTree.branches.forEach(b => {
                branches.push(b);
                branches = this.getChildsBranches(b, branches);
            });
        }
        branches.forEach(b => b.show = true);
        this.setState({ decisionsTree: decisionsTree });
    }
    closeAllCards() {
        const decisionsTree = this.state.decisionTree;
        let branches = [];
        if (decisionsTree.branches) {
            decisionsTree.branches.forEach(b => {
                branches.push(b);
                branches = this.getChildsBranches(b, branches);
            });
        }
        branches.forEach(b => b.show = false);
        this.setState({ decisionsTree: decisionsTree });
    }
    getPrecedentAndSameLevelBranches(decisionsTree, branch, branches) {
        if (!branches) {branches = [];}
        branches.push(branch);
        if (branch.branches) {
            branch.branches.forEach(b => {if (!branches.some(br => br.id === b.id)) {branches.push(b);}});
        }
        if (branch.callTreeBranchId && !branches.some(br => br.id === branch.callTreeBranchId)) {
            branches = this.getPrecedentAndSameLevelBranches(decisionsTree, this.onFindBranchById(decisionsTree, branch.callTreeBranchId), branches);
        }
        return branches;
    }
    getChildsBranches(branch, branches) {
        if (!branches) {branches = [];}
        if (branch.branches) {
            branch.branches.forEach(b => {
                if (!branches.some((br) => br.id === b.id)) {
                    branches.push(b);
                    branches = this.getChildsBranches(b, branches);
                }
            });
        }
        return branches;
    }
    openCard(decisionsTree, branch) {
        //we open the parents and all the same level cards
        this.getPrecedentAndSameLevelBranches(decisionsTree, branch, null).forEach(b => {
            b.show = true;
        });
    }
    closeCard(branch) {
        branch.show = false;
        if (branch.branches) {
            branch.branches.forEach(b => b.show = false);
        }
    }
    selectBranch(branch, levelIndex) {
        if (branch === null) {
            this.setState({ selectedCard: null });
        }
        else {
            const decisionsTree = this.state.decisionTree;
            let branches = [];
            if (decisionsTree.branches) {
                decisionsTree.branches.forEach(b => {
                    branches.push(b);
                    branches = this.getChildsBranches(b, branches);
                });
            }
            branches.forEach(b => b.show = false);
            branch.show = true;
            this.openCard(decisionsTree, branch);
            this.setState({
                decisionsTree: decisionsTree,
                selectedCard: { levelIndex: levelIndex, branch: branch }
            });
        }
    }
    CreateTempHMPLink(hmplink) {
        if (hmplink != null) {
            return JSON.parse(JSON.stringify(hmplink));
        }
        else {
            return {
                id: 0,
                callDecisionTreeId: this.state.decisionTree.id,
                name: "",
                photoURL: "",
                photoThumbnailURL: "",
                text1: "",
                text2: "",
                callCenterId: null
            };
        }
    }


    render() {
        const orgId = this.props.currentuser.currentorganization.id;
        const accessrights = this.props.currentuser && this.props.currentuser.accessrights ? this.props.currentuser.accessrights : null;

        return <div className="defaultPageContent">
            <PageMetaHelmet title={strings.DecisionTrees} icon={"/icons/favicon.ico"} />

            <div className="defaultPageWrapper">
                <div className={classNames("defaultPageContent", "verticalFlexContainer")} style={{ gap: "20px" }}>
                    {this.state.decisionTree ? <>
                        { // Title
                            <div className="horizontalFlexContainer">
                                <ButtonSKA
                                    type="secondary-icon-border-without-text"
                                    onClick={() => this.props.history.push("/Organisation?selectedPage=decisiontrees")}
                                    nameIcon="chevronLeft"
                                />
                                <span style={{ width: "14px" }}/>
                                <div className={classNames("TextHeader32", "w700")}>{this.state.decisionTree.name}</div>
                                <span style={{ flexGrow: "1", height: "100%" }}/>
                                <div style={{ display: "flex", alignContent: "center", alignItems: "center", flexDirection: "row", gap: "10px", marginRight: "20px" }}>
                                    <label className="SwitchButton">
                                        <input
                                            type="checkbox"
                                            checked={this.state.compactMode}
                                            onChange={() => {
                                                const newMode = !this.state.compactMode;
                                                if (newMode) {
                                                    this.closeAllCards();
                                                    if (this.state.selectedCard) {
                                                        const decisionsTree = this.state.decisionTree;
                                                        this.openCard(decisionsTree, this.onFindBranchById(decisionsTree, this.state.selectedCard.branch.id));
                                                        this.setState({ decisionsTree: decisionsTree });
                                                    }
                                                }
                                                this.setState({ compactMode: newMode });
                                            }}
                                        />
                                        <span className="slider"></span>
                                    </label>
                                    <div className="TextContent16" style={{ color: "var(--carbone)" }}>{strings.CompactView}</div>
                                </div>
                                { accessrights && accessrights.hasPermission(70, "modify") > 10 ? <ButtonSKA
                                    type="primary-icon"
                                    isDisabled={!this.state.hasChange}
                                    onClick={() => this.onSaveCurrent()}
                                    nameIcon="save"
                                    text={strings.register}
                                /> : null }
                            </div>
                        }
                        <div className={classNames("DecisionTreeLevelContainer", "verticalFlexContainer" )}
                            style={{ width: "calc(100% - 40px)", flex: "inherit" }}
                        >
                            <div className={classNames("TextHeader32", "w400", "primaryColor")} >
                                {strings.CallButtons}
                            </div>
                            <div className="horizontalFlexContainer" style={{ gap: "20px" }}>
                                { // HomePageLink
                                    [1, 2, 3].map((num, index) => {
                                        let hmplink = null;
                                        const title = strings.CallButtons + " #" + num;
                                        if (this.state.decisionTree && this.state.decisionTree.homePageLinks && this.state.decisionTree.homePageLinks.length >= num) {
                                            hmplink = this.state.decisionTree.homePageLinks.sort((a, b) => {return a.position - b.position;})[index];
                                            hmplink.position = index;
                                        }
                                        const isdraggable = hmplink && accessrights && accessrights.hasPermission(70, "modify") > 10;

                                        return <div key={`hmplink-${num}`} className={classNames("DecisionTreeHomeLinkContainer", "horizontalFlexContainer" )}
                                            style={{ gap: "10px", justifyContent: "flex-start", cursor: isdraggable ? "move" : "auto" }}
                                            draggable={isdraggable}
                                            onDragStart={(e) => {
                                                e.dataTransfer.setData("text/plain", index.toString());
                                            }}
                                            onDragOver={(e) => {
                                                e.stopPropagation();
                                                e.preventDefault();
                                            }}
                                            onDragEnter={(e) => {
                                                e.stopPropagation();
                                            }}
                                            onDrop={(e) => {
                                                e.stopPropagation();
                                                const datatranfer = e.dataTransfer.getData("text");
                                                if (hmplink && datatranfer && datatranfer !== "") {
                                                    const temp = JSON.parse(JSON.stringify(this.state.decisionTree));
                                                    const curposition = hmplink.position;
                                                    temp.homePageLinks[index].position = temp.homePageLinks[Number(datatranfer)].position;
                                                    temp.homePageLinks[Number(datatranfer)].position = curposition;
                                                    this.setState({
                                                        hasChange: true,
                                                        decisionTree: temp
                                                    });
                                                }
                                            }}
                                        >
                                            <Badge text={title} styleColor={hmplink ? "green" : "grey"} />
                                            {hmplink ? <span>{hmplink.name}</span> : null}
                                            <span style={{ flexGrow: "1" }}/>
                                            <ButtonSkaRound
                                                type="primary"
                                                onClick={() => this.setState({ homelinkdialog: { title: title, index: index, hmplink: this.CreateTempHMPLink(hmplink) } })}
                                                nameIcon={hmplink ? "edit" : "add"}
                                            />
                                            <ButtonSkaRound
                                                isDisabled={!accessrights || accessrights.hasPermission(70, "modify") <= 10 || !hmplink}
                                                type="primary"
                                                onClick={() => {
                                                    const tempTree = this.state.decisionTree;
                                                    tempTree.homePageLinks.splice(index, 1);
                                                    this.setState({
                                                        hasChange: true,
                                                        decisionTree: tempTree
                                                    });
                                                }}
                                                nameIcon="trash"
                                            />
                                        </div>;
                                    })
                                }
                                <Modal open={this.state.homelinkdialog}
                                    onClose={() => this.setState({ homelinkdialog: null })}
                                    title={this.state.homelinkdialog ? this.state.homelinkdialog.title : ""}
                                    icon={ "settings"}
                                    onValidate={accessrights && accessrights.hasPermission(70, "modify") > 10 ? () => {
                                        const tempTree = JSON.parse(JSON.stringify(this.state.decisionTree));
                                        if (this.state.homelinkdialog.index < tempTree.homePageLinks.length) {
                                            tempTree.homePageLinks[this.state.homelinkdialog.index] = this.state.homelinkdialog.hmplink;
                                        }
                                        else {
                                            tempTree.homePageLinks.push(this.state.homelinkdialog.hmplink);
                                        }
                                        this.setState({
                                            hasChange: true,
                                            decisionTree: tempTree,
                                            homelinkdialog: null
                                        });
                                    } : null}
                                    fields={this.state.homelinkdialog ? [
                                        {
                                            type: "textfield",
                                            title: strings.name,
                                            width: "110px",
                                            value: this.state.homelinkdialog.hmplink.name,
                                            onChange: (e) => {
                                                const tempEdit = this.state.homelinkdialog;
                                                tempEdit.hmplink.name = e.target.value;
                                                this.setState({ homelinkdialog: tempEdit });
                                            }
                                        },
                                        {
                                            type: "importfile",
                                            width: "110px",
                                            title: <span style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
                                                {strings.imageTitle}
                                                <Tooltips
                                                    htmlTooltip={strings.TooltipDimensionsImageDecisionTree}
                                                    placement="left"
                                                    htmlElementHover={
                                                        <IconComponent nameIcon="infoCircle" dimensions={24} color={"grey"}/>
                                                    }
                                                />
                                            </span>,
                                            access: "image",
                                            value: this.state.homelinkdialog.hmplink.photoName ? this.state.homelinkdialog.hmplink.photoName : "",
                                            onAddFiles: (inputFiles) => {
                                                const hpLink = this.onAddFiles(this.state.homelinkdialog.hmplink, this.state.homelinkdialog.index, inputFiles, true);
                                                const tempEdit = this.state.homelinkdialog;
                                                tempEdit.hmplink.photoName = hpLink.photoName;
                                                tempEdit.hmplink.photoURL = hpLink.photoURL;
                                                tempEdit.hmplink.photoThumbnailURL = hpLink.photoThumbnailURL;
                                                this.setState({ homelinkdialog: tempEdit });
                                            }
                                        },
                                        {
                                            type: "textfield",
                                            title: strings.Text + " 1",
                                            width: "110px",
                                            value: this.state.homelinkdialog.hmplink.text1,
                                            onChange: (e) => {
                                                const tempEdit = this.state.homelinkdialog;
                                                tempEdit.hmplink.text1 = e.target.value;
                                                this.setState({ homelinkdialog: tempEdit });
                                            }
                                        },
                                        {
                                            type: "textfield",
                                            title: strings.Text + " 2",
                                            width: "110px",
                                            value: this.state.homelinkdialog.hmplink.text2,
                                            onChange: (e) => {
                                                const tempEdit = this.state.homelinkdialog;
                                                tempEdit.hmplink.text2 = e.target.value;
                                                this.setState({ homelinkdialog: tempEdit });
                                            }
                                        },
                                        {
                                            type: "selectElement",
                                            title: strings.CallCenters,
                                            width: "110px",
                                            openTop: true,
                                            elementsList: this.props.monitoring.secondarycallcenters,
                                            selectedElementId: this.state.homelinkdialog.hmplink.callCenterId,
                                            onSelectElement: (element) => {
                                                const tempEdit = this.state.homelinkdialog;

                                                if (accessrights.hasPermission(75, "modify") === 20) {
                                                    const cucallCenterId = this.props.currentuser.user.organizationUsers.find((u) => u.organizationId === orgId).callCenterId;
                                                    if (element && element.id !== cucallCenterId) {return;}
                                                }

                                                tempEdit.hmplink.callCenterId = element ? element.id : null;
                                                this.setState({ homelinkdialog: tempEdit });
                                            }
                                        }

                                    ] : null}
                                />
                            </div>
                        </div>
                        <div className={classNames("DecisionTreeLevelContainer", "verticalFlexContainer" )} style={{ flex: 1, width: "calc(100% - 40px)" }}>
                            <div className="horizontalFlexContainer" style={{ gap: "10px" }} >
                                <div className={classNames("TextHeader32", "w400", "primaryColor")} >
                                    {"Structure"}
                                </div>
                                <span style={{ flexGrow: "1", height: "100%" }}/>
                                <Tooltips
                                    htmlTooltip={strings.TooltipDisplayDecisionTree}
                                    placement="left"
                                    htmlElementHover={
                                        <IconComponent nameIcon="infoCircle" dimensions={24} color={"grey"}/>
                                    }
                                />
                                <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                    <div style={{ display: "flex", alignContent: "center", alignItems: "center", flexDirection: "row", gap: "10px" }}>
                                        <label className="SwitchButton">
                                            <input
                                                name={"toggle"}
                                                type="checkbox"
                                                checked={this.state.decisionTree.alwaysShow}
                                                onChange={() => {
                                                    const temp = this.state.decisionTree;
                                                    temp.alwaysShow = !temp.alwaysShow;
                                                    this.setState({ decisionTree: temp, hasChange: true });
                                                }}/>
                                            <span className="slider"></span>
                                        </label>
                                        <div className="TextContent16" style={{ color: this.state.decisionTree.alwaysShow ? "var(--primary-color)" : "var(--carbone)" }}>{strings.AlwaysShow} </div>
                                    </div>
                                </div>
                                {accessrights && accessrights.hasPermission(70, "modify") > 10 ? <ButtonSkaRound
                                    type="primary"
                                    onClick={() => this.onCreateNewBranch(0, this.state.decisionTree.id)}
                                    nameIcon="add"
                                /> : null}
                            </div>
                            {
                                this.state.decisionTree.branches !== null
                                    ? this.state.decisionTree.branches
                                        .sort((a, b) => a.position - b.position)
                                        .map((branch) =>
                                            <CardDecisionTree
                                                key={branch.id}
                                                branch={branch}
                                                levelIndex={0}
                                                compactMode={this.state.compactMode}
                                                selectedCard={this.state.selectedCard}
                                                accessrights={accessrights}
                                                decisionTree={this.state.decisionTree}
                                                setDecisionTree={this.setDecisionTree}
                                                setHasChange={this.setHasChange}
                                                onFindBranchById={this.onFindBranchById}
                                                selectBranch={this.selectBranch}
                                                onCreateNewBranch={this.onCreateNewBranch}
                                                onEditBranch={this.onEditBranch}
                                                onDeleteBranch={this.onDeleteBranch}
                                            />
                                        )
                                    : null
                            }

                        </div>
                    </> : <div className={classNames("PaginationTableContainer", "verticalFlexContainer")} style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%"
                    }}>
                        <div>
                            <Loader dimensions="40px" color={"var(--primary-base)"} />
                        </div>
                    </div>}
                </div>
            </div>
            <Modal open={this.state.branchToEdit !== null && this.state.branchToEdit.levelIndex !== 2}
                onClose={() => this.setState({ branchToEdit: null })}
                title={ this.state.branchToEdit && !this.state.branchToEdit.newBranch ? strings.EditEntry : this.state.branchToEdit && this.state.branchToEdit.levelIndex === 1 ? strings.addLevel2 : strings.addLevel1}
                icon={this.state.branchToEdit && !this.state.branchToEdit.newBranch ? "edit" : "add"}
                validationIcon={this.state.branchToEdit && this.state.branchToEdit.newBranch ? "add" : null}
                validationTitle={this.state.branchToEdit && this.state.branchToEdit.newBranch ? strings.addButton : null}
                fields={this.state.branchToEdit ? [{
                    type: "textfield",
                    title: strings.Text,
                    width: "110px",
                    placeholder: "",
                    value: this.state.branchToEdit.branch.name,
                    onChange: (e) => {
                        const tempEdit = this.state.branchToEdit;
                        tempEdit.branch.name = e.target.value.replace("#", "");
                        this.setState({
                            branchToEdit: tempEdit
                        });
                    }
                }].concat(
                    [
                        {
                            type: "togglebutton",
                            title: strings.callButton,
                            width: "110px",
                            name: strings.Activate,
                            checked: this.state.branchToEdit.branch.callCenterId || this.state.branchToEdit.branch.showCallCenter,
                            onClick: () => {
                                const tempEdit = this.state.branchToEdit;
                                if (this.state.branchToEdit.branch.callCenterId || this.state.branchToEdit.branch.showCallCenter) {
                                    tempEdit.branch.callCenterId = null;
                                    tempEdit.branch.showCallCenter = false;
                                }
                                else {
                                    tempEdit.branch.callCenterId = null;
                                    tempEdit.branch.showCallCenter = true;
                                }
                                this.setState({ branchToEdit: tempEdit });
                            }
                        },
                        {
                            hide: !this.state.branchToEdit.branch.callCenterId && !this.state.branchToEdit.branch.showCallCenter,
                            type: "selectElement",
                            title: strings.CallCenters,
                            width: "110px",
                            openTop: true,
                            adjustHeight: true,
                            elementsList: this.props.monitoring.secondarycallcenters,
                            selectedElementId: this.state.branchToEdit.branch.callCenterId,
                            onSelectElement: (element) => {
                                const tempEdit = this.state.branchToEdit;

                                if (accessrights.hasPermission(75, "modify") === 20) {
                                    const cucallCenterId = this.props.currentuser.user.organizationUsers.find((u) => u.organizationId === orgId).callCenterId;
                                    if (element && element.id !== cucallCenterId) {return;}
                                }

                                tempEdit.branch.callCenterId = element ? element.id : null;
                                this.setState({ branchToEdit: tempEdit });
                            }
                        }])
                    : []}
                onValidate={accessrights && accessrights.hasPermission(70, "modify") > 10 ? () => {
                    const tempTree = this.state.decisionTree;
                    const newBranch = this.state.branchToEdit.branch;
                    const levelIndex = this.state.branchToEdit.levelIndex;
                    const branch = this.onFindBranchById(tempTree, this.state.branchToEdit.branch.id);
                    branch.name = newBranch.name;
                    branch.text = newBranch.text;
                    branch.linkURL = newBranch.linkURL;
                    branch.linkName = newBranch.linkName;
                    branch.documentName = newBranch.documentName;
                    branch.documentURL = newBranch.documentURL;
                    branch.branches = newBranch.branches;
                    branch.callCenterId = newBranch.callCenterId;
                    branch.showCallCenter = newBranch.showCallCenter;
                    this.setState({
                        hasChange: true,
                        decisionTree: tempTree,
                        branchToEdit: null,
                        selectedCard: { levelIndex: levelIndex, branch: branch }
                    });
                } : null}
            />
            <Drawer open={this.state.branchToEdit && this.state.branchToEdit.levelIndex === 2}
                onClose={() => this.setState({ branchToEdit: null })}
                title={ this.state.branchToEdit && this.state.branchToEdit.newBranch && this.state.branchToEdit.levelIndex === 2 ? strings.addLevelQuestion : strings.EditQuestion}
                validationIcon={this.state.branchToEdit && this.state.branchToEdit.newBranch && this.state.branchToEdit.levelIndex === 2 ? "add" : null}
                validationTitle={this.state.branchToEdit && this.state.branchToEdit.newBranch && this.state.branchToEdit.levelIndex === 2 ? strings.addButton : null}

                onValidate={accessrights && accessrights.hasPermission(70, "modify") > 10 ? () => {
                    const tempTree = this.state.decisionTree;
                    const newBranch = this.state.branchToEdit.branch;
                    const levelIndex = this.state.branchToEdit.levelIndex;
                    const branch = this.onFindBranchById(tempTree, this.state.branchToEdit.branch.id);
                    branch.name = newBranch.name;
                    branch.text = newBranch.text;
                    branch.linkURL = newBranch.linkURL;
                    branch.linkName = newBranch.linkName;
                    branch.documentName = newBranch.documentName;
                    branch.documentURL = newBranch.documentURL;
                    branch.branches = newBranch.branches;
                    branch.callCenterId = newBranch.callCenterId;
                    branch.showCallCenter = newBranch.showCallCenter;
                    this.setState({
                        hasChange: true,
                        decisionTree: tempTree,
                        branchToEdit: null,
                        selectedCard: { levelIndex: levelIndex, branch: branch }
                    });
                } : null}
            >
                {
                    this.state.branchToEdit ?
                        <>
                            <Inputs field={{
                                type: "textfield",
                                title: strings.questionTitle,
                                placeholder: "",
                                value: this.state.branchToEdit.branch.name,
                                onChange: (e) => {
                                    const tempEdit = this.state.branchToEdit;
                                    tempEdit.branch.name = e.target.value.replace("#", "");
                                    this.setState({
                                        branchToEdit: tempEdit
                                    });
                                }
                            }}/>
                            <Inputs field={{ type: "divider" }}/>
                            <div className="ContentTitle">{strings.Settings} </div>
                            <div style={{ border: "1px solid var(--grey-base)", borderRadius: "6px", padding: "20px" }}>
                                <Inputs field={{
                                    type: "togglebutton",
                                    title: strings.Text,
                                    bold: true,
                                    spaceBetween: true,
                                    name: strings.Activate,
                                    checked: this.state.branchToEdit.branch.text !== null,
                                    onClick: () => {
                                        const tempEdit = this.state.branchToEdit;
                                        tempEdit.branch.text = this.state.branchToEdit.branch.text === null ? "" : null;
                                        this.setState({ branchToEdit: tempEdit });
                                    }
                                }}/>
                                {
                                    this.state.branchToEdit.branch.text !== null ?
                                        <div>
                                            <span style={{ display: "block", height: "20px" }}></span>
                                            <Inputs field={{
                                                type: "textarea",
                                                value: this.state.branchToEdit.branch.text,
                                                onChange: (e) => {
                                                    const tempEdit = this.state.branchToEdit;
                                                    tempEdit.branch.text = e.target.value;
                                                    this.setState({ branchToEdit: tempEdit });
                                                }
                                            }}/>
                                        </div>
                                        :
                                        null
                                }
                            </div>
                            <div style={{ border: "1px solid var(--grey-base)", borderRadius: "6px", padding: "20px" }}>
                                <Inputs field={{
                                    type: "togglebutton",
                                    title: strings.imageTitle,
                                    bold: true,
                                    spaceBetween: true,
                                    name: strings.Activate,
                                    checked: this.state.branchToEdit.branch.documentName !== null,
                                    onClick: () => {
                                        const tempEdit = this.state.branchToEdit;
                                        if (tempEdit.branch.documentName === null) {
                                            tempEdit.branch.documentName = "";
                                        }
                                        else {
                                            tempEdit.branch.documentName = null;
                                            tempEdit.branch.documentURL = null;
                                        }
                                        this.setState({ branchToEdit: tempEdit });
                                    }
                                }}/>
                                {
                                    this.state.branchToEdit.branch.documentName !== null ?
                                        <div>
                                            <span style={{ display: "block", height: "20px" }}></span>
                                            <Inputs field={{
                                                type: "importfile",
                                                title: strings.File,
                                                width: "100px",
                                                access: "image",
                                                value: this.state.branchToEdit.branch.documentURL ? this.state.branchToEdit.branch.documentName : "",
                                                onAddFiles: (inputFiles) => {
                                                    const newBranch = this.onAddFiles(this.state.branchToEdit.branch, this.state.branchToEdit.levelIndex, inputFiles);
                                                    const tempEdit = this.state.branchToEdit;
                                                    tempEdit.branch.documentName = newBranch.documentName;
                                                    tempEdit.branch.documentURL = newBranch.documentURL;
                                                    this.setState({ branchToEdit: tempEdit });
                                                }
                                            }} />
                                        </div>
                                        :
                                        null
                                }
                            </div>
                            <div style={{ border: "1px solid var(--grey-base)", borderRadius: "6px", padding: "20px" }}>
                                <Inputs field={{
                                    type: "togglebutton",
                                    title: strings.webLink,
                                    bold: true,
                                    spaceBetween: true,
                                    name: strings.Activate,
                                    checked: this.state.branchToEdit.branch.linkName !== null,
                                    onClick: () => {
                                        const tempEdit = this.state.branchToEdit;
                                        if (tempEdit.branch.linkName === null) {
                                            tempEdit.branch.linkName = "";
                                            tempEdit.branch.linkURL = "";
                                        }
                                        else {
                                            tempEdit.branch.linkName = null;
                                            tempEdit.branch.linkURL = null;
                                        }
                                        this.setState({ branchToEdit: tempEdit });
                                    }
                                }}/>
                                {
                                    this.state.branchToEdit.branch.linkName !== null ?
                                        <div>
                                            <span style={{ display: "block", height: "20px" }}></span>
                                            <Inputs field={{
                                                type: "prefixedTextfield",
                                                prefix: "https://",
                                                title: strings.feedUrl,
                                                width: "100px",
                                                value: this.state.branchToEdit.branch.linkURL,
                                                onChange: (e) => {
                                                    const tempEdit = this.state.branchToEdit;
                                                    tempEdit.branch.linkURL = e.target.value;
                                                    this.setState({ branchToEdit: tempEdit });
                                                }
                                            }} />
                                            <span style={{ display: "block", height: "20px" }}></span>
                                            <Inputs field={{
                                                type: "textfield",
                                                title: strings.TextDisplayed,
                                                width: "100px",
                                                value: this.state.branchToEdit.branch.linkName,
                                                onChange: (e) => {
                                                    const tempEdit = this.state.branchToEdit;
                                                    tempEdit.branch.linkName = e.target.value;
                                                    this.setState({ branchToEdit: tempEdit });
                                                }
                                            }} />
                                        </div>
                                        :
                                        null
                                }
                            </div>
                            <div style={{ border: "1px solid var(--grey-base)", borderRadius: "6px", padding: "20px" }}>
                                <Inputs field={{
                                    type: "togglebutton",
                                    title: strings.callButton,
                                    width: "150px",
                                    bold: true,
                                    spaceBetween: true,
                                    name: strings.Activate,
                                    checked: this.state.branchToEdit.branch.callCenterId || this.state.branchToEdit.branch.showCallCenter,
                                    onClick: () => {
                                        const tempEdit = this.state.branchToEdit;
                                        if (this.state.branchToEdit.branch.callCenterId || this.state.branchToEdit.branch.showCallCenter) {
                                            tempEdit.branch.callCenterId = null;
                                            tempEdit.branch.showCallCenter = false;
                                        }
                                        else {
                                            tempEdit.branch.callCenterId = null;
                                            tempEdit.branch.showCallCenter = true;
                                        }
                                        this.setState({ branchToEdit: tempEdit });
                                    }
                                }}/>
                                {
                                    this.state.branchToEdit.branch.callCenterId !== null && this.state.branchToEdit.branch.showCallCenter !== null ?
                                        <div>
                                            <span style={{ display: "block", height: "20px" }}></span>
                                            <Inputs field={{
                                                type: "selectElement",
                                                title: strings.CallCenters,
                                                width: "110px",
                                                openTop: true,
                                                adjustHeight: true,
                                                elementsList: this.props.monitoring.secondarycallcenters,
                                                selectedElementId: this.state.branchToEdit.branch.callCenterId,
                                                onSelectElement: (element) => {
                                                    const tempEdit = this.state.branchToEdit;

                                                    if (accessrights.hasPermission(75, "modify") === 20) {
                                                        const cucallCenterId = this.props.currentuser.user.organizationUsers.find((u) => u.organizationId === orgId).callCenterId;
                                                        if (element && element.id !== cucallCenterId) {return;}
                                                    }

                                                    tempEdit.branch.callCenterId = element ? element.id : null;
                                                    this.setState({ branchToEdit: tempEdit });
                                                }
                                            }} />
                                        </div>
                                        :
                                        null
                                }
                            </div>
                        </> : null
                }
            </Drawer>
        </div>;
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default connect(
    (state) => state,
    mapDispatchToProps
)(EditDecisionTree);
